export const theme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#22c55e',
      primary25: '#dcfce7',
      primary50: '#bbf7d0',
    },
});